import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'musteri';

var musteriService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,
    logoPath: WsProvider.yatirimciLogo + 'belge/musteri/logo/',
    musteriLogoSil(id) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': id,
            serviceName: moduleName,
            methodName: 'resimSil',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriListesi(durum, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'musteriListesi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    getCustomerListUnlimited() {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            serviceName: moduleName,
            methodName: 'listele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriProjeBaslik() {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            serviceName: moduleName,
            methodName: 'musteriProjeBaslik',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriProjeleri(baslangic, musteriID, durum) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            ['data[baslangic]']: baslangic,
            ['data[musteriID]']: musteriID,
            ['data[durum]']: durum,
            serviceName: moduleName,
            methodName: 'musteriProjeleri',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriListesi2(durum, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            durum: durum,
            baslangic: baslangic,
            limit,
            serviceName: moduleName,
            methodName: 'musteriListesi2',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriBilgiListesi(id) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': id,
            serviceName: moduleName,
            methodName: 'musteriBilgiListesi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriDetay(musteriID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': musteriID,
            serviceName: moduleName,
            methodName: 'musteriDetay',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriRapor(musteriID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            musteriID,
            serviceName: moduleName,
            methodName: 'musteriRapor',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriEkle({
                    musteriAdi,
                    unvan,
                    telefon,
                    eposta,
                    vergiDairesi,
                    vergiNo,
                    website,
                    adres,
                    durum,
                    logo,
                    not
                }, ekstralar) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[not]': not,
            'data[musteriAdi]': musteriAdi,
            'logo': logo[0],
            'data[unvan]': unvan,
            'data[eposta]': eposta,
            'data[telefon]': telefon,
            'data[vergiDairesi]': vergiDairesi,
            'data[vergiNo]': vergiNo,
            'data[website]': website,
            'data[adres]': adres,
            'data[durum]': durum,
            methodName: 'musteriEkle',
            serviceName: moduleName,
        };
        if (typeof ekstralar.map === 'function') {
            ekstralar.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    param[`data[ekBilgi][${index}][${key}]`] = item[key];
                });
            });
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriFilter(firmaAdi, unvan, adres, telefon, eposta, durum, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[firmaAdi]': firmaAdi,
            'data[unvan]': unvan,
            'data[adres]': adres,
            'data[telefon]': telefon,
            'data[eposta]': eposta,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'musteriArama',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriSayisi(durum) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            durum: durum,
            serviceName: moduleName,
            methodName: 'musteriSayisi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    customerInfoUpdate(info, musteriID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[id]': info.musteriDetayID || '',
            'data[musteriID]': musteriID || '',
            'data[adSoyad]': info.yetkiliAdSoyad,
            'data[telefon]': info.yetkiliTelefon,
            'data[eposta]': info.yetkiliEposta,
            'data[unvan]': info.yetkiliUnvan,
            serviceName: moduleName,
            methodName: 'musteriBilgiDuzenle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    customerInfoStatusUpdate(id, type) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[id]': id,
            'data[durum]': type === 'active' ? 1 : 0,
            serviceName: moduleName,
            methodName: 'musteriBilgiDurumDuzenle',
        };

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    /*
    musteriAktifPasifSayisi() {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            serviceName: moduleName,
            methodName: "musteriAktifPasifSayisi"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },*/
    //  musteriSiparisListesi(musteriKodu, baslangic, limit) {},
    /*
    siparisListele(musteriID, baslangic, limit) {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            musteriID,
            durum: 30,
            serviceName: moduleName,
            baslangic,
            limit,
            methodName: "musteriSiparisListele"
        }
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },*/
    musteriGuncelleYeni(musteriID, form, ekBilgi) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': musteriID,
            'data[not]': form.not,
            'logo': form.logo[0] != undefined ? form.logo[0] : '',
            'data[unvan]': form.unvan,
            'data[telefon]': form.telefon,
            'data[eposta]': form.eposta,
            'data[adres]': form.adres,
            'data[website]': form.website,
            'data[musteriAdi]': form.musteriAdi,
            'data[vergiNo]': form.vergiNo,
            'data[vergiDairesi]': form.vergiDairesi,
            'data[durum]': form.durum,
            serviceName: moduleName,
            methodName: 'musteriDuzenle',
        };
        ekBilgi.forEach((item, i) => {
            param[`data[ekBilgi][${i}][adSoyad]`] = item.yetkiliAdSoyad
            param[`data[ekBilgi][${i}][eposta]`] = item.yetkiliEposta
            param[`data[ekBilgi][${i}][telefon]`] = item.yetkiliTelefon
            param[`data[ekBilgi][${i}][unvan]`] = item.yetkiliUnvan
        })
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    musteriGuncelle(musteriID, updateList) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': musteriID,
            'data[not]': updateList.not,
            'data[logo]': updateList.logo[0],
            'data[unvan]': updateList.unvan,
            'data[telefon]': updateList.telefon,
            'data[eposta]': updateList.eposta,
            'data[adres]': updateList.adres,
            'data[website]': updateList.website,
            'data[musteriAdi]': updateList.musteriAdi,
            'data[vergiNo]': updateList.vergiNo,
            'data[vergiDairesi]': updateList.vergiDairesi,
            'data[durum]': updateList.durum,
            serviceName: moduleName,
            methodName: 'musteriDuzenle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    customerStatusUpdate(musteriID, durum) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');

        var param = {
            token: userDataDemirag,
            'data[musteriID]': musteriID,
            'data[durum]': durum,
            serviceName: moduleName,
            methodName: 'musteriDurumDuzenle',
        };

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    musteriSifreGuncelle(musteriID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            musteriID,
            serviceName: moduleName,
            methodName: 'musteriSifreGuncelle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};

export default musteriService;
